<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-12">
        <h3 class="blue-text">{{L10n('rfq-general')}}</h3>
      </div>
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('rfq-id')"
          prop="rfqid"
          class="material-style">
          <el-input
            ref="firstField"
            disabled
            :value="form.rfqid"/>
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('entry-date')"
          :rules="getValidationRule('required')"
          prop="entryDate"
          class="material-style"
        >
          <date-picker
            v-model="form.entryDate"
            @change="updateModelItem('entryDate', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('rfq-type')"
          prop="rfqTypeID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.rfqTypeID"
            @update:model="updateModelItem('rfqTypeID', { required: true })"
            :isLoading="dataSourceRfqType.loading"
            :data="dataSourceRfqType.records"
          />
        </el-form-item>
      </div>

      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('customer')"
          prop="customerCompanyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model.sync="form.customerCompanyID"
            @on-created="mixCreateCustomer"
            @on-change="(id) => mixChangeCustomerID(id, {required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('customer-detail')"
          prop="customerCompanyDetailID"
          class="material-style">
          <select-company-detail
            withAutoSelect
            :model.sync="form.customerCompanyDetailID"
            :companyID="form.customerCompanyID"
            @update:model="updateModelItem('customerCompanyDetailID', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('customer-contact')"
          prop="customerContactID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-company-contact
            :model.sync="form.customerContactID"
            :companyID="form.customerCompanyID"
            @update:model="updateModelItem('customerContactID', { required: true })"
          />
        </el-form-item>
      </div>

      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('customer-po')"
          prop="po"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.po"
            @input="form.po = valueTrimLeft($event)"
            @change="updateModelItem('po', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('po-date')"
          :rules="getValidationRule('required')"
          prop="poDate"
          class="material-style"
        >
          <date-picker
            v-model="form.poDate"
            @change="updateModelItem('poDate', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('employee')"
          :rules="getValidationRule('required')"
          prop="baxEmployeeID"
          class="material-style"
        >
          <select-response
            :model.sync="form.baxEmployeeID"
            @update:model="updateModelItem('baxEmployeeID', { required: true })"
            :data="dataSourceEmployee.records"
            :isLoading="dataSourceEmployee.loading"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { mixUpdateCustomer } from '@/mixins/companies'

export default {
  name: 'FormRFQ',
  mixins: [Form, mixUpdateCustomer],
  components: {
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue'),
    'select-company-detail': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyDetail/Index.vue')
  },
  props: {
    dataID: { required: true }
  },
  computed: {
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true')
    },
    dataSourceRfqType () {
      return this.API('RFQTypes/GetAllDynamic?select=id,title')
    },
    dataSourceScore () {
      return this.API('Scores/GetAllDynamic?select=id,scoreText as title&filter=scoreIndex==3')
    }
  },
  methods: {
    updateModelItem (fieldName, payload = {}) {
      let payloadMixin = { api: `RFQs/Patch/${this.dataID}`, id: this.dataID }
      this.$emit('updateModelItem', fieldName, this.form[fieldName], { ...payloadMixin, ...payload })
    }
  }
}
</script>
